import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  authFormContainer: {
    height: '100vh',
  },
  authFormPaper: {
    padding: '1rem',
  },
  authFormHeader: {
    marginBottom: '1rem',
  },
  authFormIcon: {
    fontSize: '3rem',
  },
  authFormInputs: {
    marginBottom: '1rem',
  },
  authFormButton: {
    textTransform: 'none',
  },
  wrapper: {
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}))
export default useStyles
